import React, { Component } from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

export class NotificationErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('[NotificationErrorBoundary] Caught render error in notification:', error);
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
